module.exports = __webpack_public_path__ + "img/02.52d4613a.png";